import React from 'react';
import { Map, LayersControl, Marker } from 'react-leaflet';
import PropTypes from 'prop-types';
import L from 'leaflet';
import { GoogleLayer } from 'react-leaflet-google';
import CustomLayer from '../../Map/Layers/Custom';
import { API_KEY } from '../../../config';
import { MAP_TYPES } from '../../../constants';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

import getPropertyIcon from '../../../utils/getPropertyIcon';

import buildingMarker from '../../Map/buildingMarker.png';
import siteMarker from '../../Map/siteMarker.png';

import './PropertyDetailMap.css';

const { BaseLayer } = LayersControl;

const PropertyDetailMap = ({ property, type, viewer }) => {
  const { basicInfo, attachments = {} } = property;
  const { geoLocation } = basicInfo.location;
  const { markers } = viewer;
  const location = geoLocation && geoLocation.coordinates && geoLocation.coordinates.length
    ? {
      lat: geoLocation.coordinates[1],
      lng: geoLocation.coordinates[0],
    }
    : undefined;
  const defaultCustomLayers = [];
  const showLayers = attachments.outline ? attachments.outline.showByDefault : false;
  if (showLayers) {
    defaultCustomLayers.push(attachments.outline);
  }
  const defaultIcon = type === 'buildings' ? buildingMarker : siteMarker;
  const icon = getPropertyIcon(property, type, defaultIcon, markers);
  return (
    <section>
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h4 className="section-title">Map</h4>
      </ViewerPrimaryColorUserStyle>
      <div className="property-detail-map section-body">
        {location === undefined &&
          <div>Map is not available for this property.</div>
        }
        {location &&
        <div className="property-detail-map-wrapper">
          <Map center={location} zoom={18} scrollWheelZoom={false}>
            {showLayers && defaultCustomLayers.map((layer, index) =>
              <CustomLayer
                key={layer.id + index.toString()}
                onBoundsUpdate={() => {}}
                shapefile={layer}
              />,
            )}
            <LayersControl position="topright">
              <BaseLayer checked name="Roads">
                <GoogleLayer googlekey={API_KEY} maptype={MAP_TYPES.ROADMAP} libraries={['geometry', 'places']} />
              </BaseLayer>
              <BaseLayer name="Terrain">
                <GoogleLayer googlekey={API_KEY} maptype={MAP_TYPES.TERRAIN} libraries={['geometry', 'places']} />
              </BaseLayer>
              <BaseLayer name="Satellite">
                <GoogleLayer googlekey={API_KEY} maptype={MAP_TYPES.SATELLITE} libraries={['geometry', 'places']} />
              </BaseLayer>
              <BaseLayer name="Hybrid">
                <GoogleLayer googlekey={API_KEY} maptype={MAP_TYPES.HYBRID} libraries={['geometry', 'places']} />
              </BaseLayer>
            </LayersControl>
            {/* <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
            /> */}
            <Marker
              key={property._id}
              position={location}
              icon={
                L.icon(
                  {
                    iconUrl: icon,
                    className: 'property-detail-map-icon',
                    iconSize: [26, 35],
                    iconAnchor: [13, 36],
                  },
                )
              }
            />
          </Map>
        </div>
        }
      </div>
    </section>
  );
};

PropertyDetailMap.propTypes = {
  type: PropTypes.string,
  property: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default PropertyDetailMap;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailMap/PropertyDetailMap.js